import api from '../../plugins/api';

// POST /api/crm/onboarding/reset â Â«ÐÑÐ¾Ð¹ÑÐ¸ Ð¾Ð±ÑÑÐµÐ½Ð¸Ðµ Ð·Ð°Ð½Ð¾Ð²Ð¾Â».
const resetOnboarding = () => {
  return api.post('/api/crm/onboarding/reset');
};

export default resetOnboarding;
